import c from '../constant';
const getShortDepartmentLabel = (value) => {
	let label = '';
	c.departments.map((d) => {
		if (d.value === value) {
			label = d.labelShort;
		}
	});
	return label;
};

export default getShortDepartmentLabel;
